module.exports = __webpack_public_path__ + "img/btn_spin.3d128286.png";